'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import type { JSX } from 'react';
import InfoTooltip from '@/components/molecules/InfoTooltip';
import FeesColumn from './partials/FeesColumn';

/**
 * Props for `Fees`.
 */
export type FeesProps = SliceComponentProps<Content.FeesSlice>;

/**
 * Component for "Fees" Slices.
 */
const Fees = t0 => {
  const $ = _c(41);
  const {
    slice
  } = t0;
  let firstColumnRows;
  let rows;
  let t1;
  if ($[0] !== slice.items) {
    rows = slice.items.map(_temp);
    firstColumnRows = rows.slice(0, Math.ceil(rows.length / 2));
    t1 = rows.slice(Math.ceil(rows.length / 2));
    $[0] = slice.items;
    $[1] = firstColumnRows;
    $[2] = rows;
    $[3] = t1;
  } else {
    firstColumnRows = $[1];
    rows = $[2];
    t1 = $[3];
  }
  const secondColumnRows = t1;
  let t2;
  if ($[4] !== slice.primary.tableHeader) {
    t2 = <p className="text-h8 text-primary-600 font-bold">{slice.primary.tableHeader}</p>;
    $[4] = slice.primary.tableHeader;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== slice.primary.tooltipDescription || $[7] !== slice.primary.tooltipTitle) {
    t3 = <InfoTooltip title={slice.primary.tooltipTitle} description={slice.primary.tooltipDescription} data-sentry-element="InfoTooltip" data-sentry-source-file="index.tsx" />;
    $[6] = slice.primary.tooltipDescription;
    $[7] = slice.primary.tooltipTitle;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className="bg-primary-200 mb-4 flex flex-row items-center justify-center gap-2 rounded-lg py-3.5">{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== firstColumnRows) {
    t5 = <FeesColumn rows={firstColumnRows} className="hidden md:block" data-sentry-element="FeesColumn" data-sentry-source-file="index.tsx" />;
    $[12] = firstColumnRows;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== secondColumnRows) {
    t6 = <FeesColumn rows={secondColumnRows} className="hidden md:block" data-sentry-element="FeesColumn" data-sentry-source-file="index.tsx" />;
    $[14] = secondColumnRows;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== rows) {
    t7 = <FeesColumn rows={rows} className="md:hidden" data-sentry-element="FeesColumn" data-sentry-source-file="index.tsx" />;
    $[16] = rows;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
    t8 = <div className="grid grid-cols-1 grid-rows-1 gap-4 md:grid-cols-2">{t5}{t6}{t7}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t4 || $[23] !== t8) {
    t9 = <div className="order-2 flex shrink-0 flex-col lg:order-1">{t4}{t8}</div>;
    $[22] = t4;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== slice.primary.subtitle) {
    t10 = <p className="text-caption-1 text-primary-600 mb-4 font-bold">{slice.primary.subtitle}</p>;
    $[25] = slice.primary.subtitle;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <br className="hidden lg:block" />;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== slice.primary.titleFirstLine || $[29] !== slice.primary.titleSecondLine) {
    t12 = <h2 className="text-h3 md:text-h2 font-bold text-gray-600">{slice.primary.titleFirstLine} {t11}{slice.primary.titleSecondLine}</h2>;
    $[28] = slice.primary.titleFirstLine;
    $[29] = slice.primary.titleSecondLine;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t10 || $[32] !== t12) {
    t13 = <div className="order-1 lg:order-2">{t10}{t12}</div>;
    $[31] = t10;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t13 || $[35] !== t9) {
    t14 = <div className="flex flex-col gap-10 lg:flex-row lg:items-center lg:gap-34">{t9}{t13}</div>;
    $[34] = t13;
    $[35] = t9;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== slice.slice_type || $[38] !== slice.variation || $[39] !== t14) {
    t15 = <section data-slice-type={slice.slice_type} data-slice-variation={slice.variation} className="o-container o-container--xl pb-24 lg:pb-44" data-sentry-component="Fees" data-sentry-source-file="index.tsx">{t14}</section>;
    $[37] = slice.slice_type;
    $[38] = slice.variation;
    $[39] = t14;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  return t15;
};
export default Fees;
function _temp(item) {
  return {
    icon: item.rowIcon,
    label: item.rowLabel,
    value: item.rowValue
  };
}